module.exports = __webpack_public_path__ + "static/img/ikonaCwiczenie-ON.2e752696.png";